import { TriangleAlert } from 'lucide-react';
import { Button } from '../actions/Button';
import { isApiError } from '../../lib/api/errors';

/**
 * Inline error for a panel whose query failed and set `meta.silent` (the
 * global modal covers the rest). Shows the BE's message and correlation id,
 * and a retry when the caller passes one. The kit specifies no error state.
 */
export function ErrorState({
  error,
  onRetry,
  compact = false,
}: {
  error: unknown;
  onRetry?: () => void;
  compact?: boolean;
}) {
  const message = isApiError(error) ? error.userMessage : "We couldn't load this.";
  const correlationId = isApiError(error) ? error.correlationId : undefined;
  return (
    <div
      role="alert"
      className={`flex flex-col items-center gap-2 text-center font-body ${compact ? 'py-6' : 'py-10'}`}
    >
      <TriangleAlert size={20} strokeWidth={2} aria-hidden="true" className="text-danger" />
      <p className="m-0 text-sm text-ink">{message}</p>
      {correlationId && <p className="m-0 font-mono text-xs text-muted">ID: {correlationId}</p>}
      {onRetry && (
        <Button variant="ghost-dark" size="sm" onClick={onRetry} className="mt-1">
          Try again
        </Button>
      )}
    </div>
  );
}
